<template>
  <div class="wl-your-prices mt-3" v-if="template">
    <div class="row" v-if="!viewMode">
      <div class="col col-lg-4">
        <b-form-group>
          <b-form-radio-group id="radio-show-mode" v-model="show_mode">
            <b-form-radio value="prices">Show Prices</b-form-radio>
            <b-form-radio value="margins">Show Margins</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </div>
      <div class="col col-lg-4 offset-lg-4">
        <b-form-group class="mb-2" label="Target margin:">
          <b-input-group size="sm">
            <b-form-input
              id="target-margin"
              type="text"
              placeholder="Target margin"
              v-model="target_margin"
            ></b-form-input>
            <b-input-group-append is-text> % </b-input-group-append>
            <b-input-group-append>
              <b-button
                size="sm"
                text="Button"
                @click="set_target_margin"
                variant="primary"
                >Set</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>
    </div>

    <draggable v-model="template" handle=".group-handle" @end="update_order">
      <div class="wl-group" v-for="(group, index) in template" :key="index">
        <div class="row">
          <div class="col">
            <h5
              class="wl-group-header"
              :class="{ 'group-handle': editable }"
              v-if="group.name"
            >
              <svg
                class="bi"
                fill="currentColor"
                width="17px"
                height="17px"
                v-if="editable"
              >
                <use
                  xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#arrows-move"
                />
              </svg>
              {{ group.name }}
            </h5>
          </div>
        </div>
        <div class="w-100">
          <table class="table">
            <thead>
              <tr>
                <th v-if="editable"></th>
                <th>Description</th>
                <th>Case Size</th>
                <th>Invoice Price</th>
                <th>125ml</th>
                <th>175ml</th>
                <th>250ml</th>
                <th v-if="editable"></th>
              </tr>
            </thead>
            <draggable
              v-model="group.items"
              tag="tbody"
              handle=".handle"
              @end="update_order"
            >
              <tr
                class="wl-data-table-row"
                v-for="item in group.items"
                :key="item.product._id"
                :class="{ 'opacity-1': item.hide }"
              >
                <td class="handle" v-if="editable">
                  <svg
                    class="bi my-1"
                    fill="currentColor"
                    width="18px"
                    height="18px"
                  >
                    <use
                      xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#arrows-move"
                    />
                  </svg>
                </td>
                <td>
                  <a :href="item.product._source.Permalink" target="_blank">{{
                    item.product._source.ItemDescription[0]
                  }}</a
                  ><br />
                  <small>LWIN: {{ item.item_code.substr(0, 7) }}</small>
                </td>
                <td>{{ item.product._source.CaseSize }}</td>
                <td>
                  {{ item.actual_price | currency }}
                </td>

                <td class="wl-price-input-col" v-if="!viewMode">
                  <div v-if="show_mode === 'prices'">
                    <b-input-group size="sm" prepend="£">
                      <b-form-input
                        type="tel"
                        no-wheel
                        size="sm"
                        debounce="500"
                        v-model.number.lazy="item.price_125ml"
                        @input="make_dirty"
                        @change="
                          update_125_price(item.item_code, item.price_125ml)
                        "
                      ></b-form-input>
                    </b-input-group>
                    <small>Margin: {{ margin_125(item) | percentage }}</small>
                  </div>
                  <div v-if="show_mode === 'margins'">
                    <b-input-group size="sm" append="%">
                      <b-form-input
                        type="tel"
                        no-wheel
                        size="sm"
                        :value="margin_125(item).toFixed(2)"
                        @input="make_dirty"
                        @change="update_125_margin(item, $event)"
                      ></b-form-input>
                    </b-input-group>
                    <small>Price: {{ item.price_125ml | currency }}</small>
                  </div>
                </td>
                <td v-else>
                  {{ item.price_125ml | currency }}
                </td>
                <td class="wl-price-input-col" v-if="!viewMode">
                  <div v-if="show_mode === 'prices'">
                    <b-input-group size="sm" prepend="£">
                      <b-form-input
                        type="tel"
                        no-wheel
                        size="sm"
                        debounce="500"
                        v-model.number.lazy="item.price_175ml"
                        @input="make_dirty"
                        @change="
                          update_175_price(item.item_code, item.price_175ml)
                        "
                      ></b-form-input>
                    </b-input-group>
                    <small>Margin: {{ margin_175(item) | percentage }}</small>
                  </div>
                  <div v-if="show_mode === 'margins'">
                    <b-input-group size="sm" append="%">
                      <b-form-input
                        type="tel"
                        no-wheel
                        size="sm"
                        :value="margin_175(item).toFixed(2)"
                        @input="make_dirty"
                        @change="update_175_margin(item, $event)"
                      ></b-form-input>
                    </b-input-group>
                    <small>Price: {{ item.price_175ml | currency }}</small>
                  </div>
                </td>
                <td v-else>
                  {{ item.price_175ml | currency }}
                </td>
                <td class="wl-price-input-col" v-if="!viewMode">
                  <div v-if="show_mode === 'prices'">
                    <b-input-group size="sm" prepend="£">
                      <b-form-input
                        type="tel"
                        no-wheel
                        size="sm"
                        debounce="500"
                        v-model.number.lazy="item.price_250ml"
                        @input="make_dirty"
                        @change="
                          update_250_price(item.item_code, item.price_250ml)
                        "
                      ></b-form-input>
                    </b-input-group>
                    <small>Margin: {{ margin_250(item) | percentage }}</small>
                  </div>
                  <div v-if="show_mode === 'margins'">
                    <b-input-group size="sm" append="%">
                      <b-form-input
                        type="tel"
                        no-wheel
                        size="sm"
                        :value="margin_250(item).toFixed(2)"
                        @input="make_dirty"
                        @change="update_250_margin(item, $event)"
                      ></b-form-input>
                    </b-input-group>
                    <small>Price: {{ item.price_250ml | currency }}</small>
                  </div>
                </td>
                <td v-else>
                  {{ item.price_250ml | currency }}
                </td>
                <td v-if="editable">
                  <div class="wl-brochure-actions text-center">
                    <b-link
                      class="mb-1"
                      @click="
                        item.hide = !item.hide;
                        hide_item(item.item_code, item.hide);
                      "
                    >
                      <svg
                        class="bi"
                        fill="currentColor"
                        width="17px"
                        height="17px"
                      >
                        <use
                          xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#eye-slash"
                        />
                      </svg> </b-link
                    ><br />
                    <b-link
                      @click="
                        $emit('remove-item', { item_code: item.item_code })
                      "
                      ><svg
                        class="bi"
                        fill="currentColor"
                        width="17px"
                        height="17px"
                      >
                        <use
                          xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#x-square"
                        />
                      </svg>
                    </b-link>
                  </div>
                </td>
              </tr>
            </draggable>
          </table>
        </div>
      </div>
    </draggable>
  </div>
</template>


<script>
import Draggable from "vuedraggable";

export default {
  components: {
    Draggable,
  },
  props: {
    value: {
      type: Array,
    },
    slug: {
      type: String,
    },
    presentationMode: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    targetMargin: {
      type: Number,
      default: 0,
    },
    viewMode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    margin_75: () => (item) => {
      return (
        ((item.price_75ml / 1.2 - (item.actual_price / item.volume) * 75) /
          (item.price_75ml / 1.2)) *
        100
      );
    },
    margin_125: () => (item) => {
      return (
        ((item.price_125ml / 1.2 - (item.actual_price / item.volume) * 125) /
          (item.price_125ml / 1.2)) *
        100
      );
    },
    margin_175: () => (item) => {
      return (
        ((item.price_175ml / 1.2 - (item.actual_price / item.volume) * 175) /
          (item.price_175ml / 1.2)) *
        100
      );
    },
    margin_250: () => (item) => {
      return (
        ((item.price_250ml / 1.2 - (item.actual_price / item.volume) * 250) /
          (item.price_250ml / 1.2)) *
        100
      );
    },
  },
  mounted() {
    this.data_incoming = true;
    this.template = JSON.parse(JSON.stringify(this.value));
    this.target_margin = this.targetMargin;
  },
  methods: {
    make_dirty() {
      this.dirty = true;
    },
    update_75_margin(item, margin) {
      margin = parseFloat(margin);

      item.price_75ml = (
        (((item.actual_price / ((100 - margin) / 100)) * 1.2) / item.volume) *
        75
      ).toFixed(2);

      this.update_75_price(item.item_code, item.price_75ml);
    },
    update_125_margin(item, margin) {
      margin = parseFloat(margin);

      item.price_125ml = (
        (((item.actual_price / ((100 - margin) / 100)) * 1.2) / item.volume) *
        125
      ).toFixed(2);

      this.update_125_price(item.item_code, item.price_125ml);
    },
    update_175_margin(item, margin) {
      margin = parseFloat(margin);

      item.price_175ml = (
        (((item.actual_price / ((100 - margin) / 100)) * 1.2) / item.volume) *
        175
      ).toFixed(2);

      this.update_175_price(item.item_code, item.price_175ml);
    },
    update_250_margin(item, margin) {
      margin = parseFloat(margin);

      item.price_250ml = (
        (((item.actual_price / ((100 - margin) / 100)) * 1.2) / item.volume) *
        250
      ).toFixed(2);

      this.update_250_price(item.item_code, item.price_250ml);
    },
    update_75_price(item_code, price_75ml) {
      this.$emit("update-item", {
        item_code,
        price_75ml,
      });
      this.dirty = false;
    },
    update_125_price(item_code, price_125ml) {
      this.$emit("update-item", {
        item_code,
        price_125ml,
      });
      this.dirty = false;
    },
    update_175_price(item_code, price_175ml) {
      this.$emit("update-item", {
        item_code,
        price_175ml,
      });
      this.dirty = false;
    },
    update_250_price(item_code, price_250ml) {
      this.$emit("update-item", {
        item_code,
        price_250ml,
      });
      this.dirty = false;
    },
    hide_item(item_code, hide) {
      this.$emit("hide-item", {
        template: "PRICE",
        data: {
          item_code,
          hide,
        },
      });
    },
    update_order() {
      this.$emit("update-order", {
        template: "PRICE",
        data: {
          groups: this.template,
        },
      });
    },
    set_target_margin() {
      this.$bvModal
        .msgBoxConfirm(
          "Are you sure you want to set all prices based on a target margin of " +
            this.target_margin +
            "%?"
        )
        .then((state) => {
          if (state) {
            for (var i in this.template) {
              for (var j in this.template[i].items) {
                this.template[i].items[j].price_75ml = (
                  (((this.template[i].items[j].actual_price /
                    ((100 - this.target_margin) / 100)) *
                    1.2) /
                    this.template[i].items[j].volume) *
                  75
                );

                this.template[i].items[j].price_125ml = (
                  (((this.template[i].items[j].actual_price /
                    ((100 - this.target_margin) / 100)) *
                    1.2) /
                    this.template[i].items[j].volume) *
                  125
                );

                this.template[i].items[j].price_175ml = (
                  (((this.template[i].items[j].actual_price /
                    ((100 - this.target_margin) / 100)) *
                    1.2) /
                    this.template[i].items[j].volume) *
                  175
                );

                this.template[i].items[j].price_250ml = (
                  (((this.template[i].items[j].actual_price /
                    ((100 - this.target_margin) / 100)) *
                    1.2) /
                    this.template[i].items[j].volume) *
                  250
                );

                this.template[i].items[j].price_75ml = (Math.round(this.template[i].items[j].price_75ml*20)/20).toFixed(2);
                this.template[i].items[j].price_125ml = (Math.round(this.template[i].items[j].price_125ml*20)/20).toFixed(2);
                this.template[i].items[j].price_175ml = (Math.round(this.template[i].items[j].price_175ml*20)/20).toFixed(2);
                this.template[i].items[j].price_250ml = (Math.round(this.template[i].items[j].price_250ml*20)/20).toFixed(2);

              }

              
            } 

            this.$store.dispatch("winelist/save_margins", {
              id: this.slug,
              items: this.template,
              target_margin_glass: this.target_margin,
            });
          }
        });
    },
  },
  watch: {
    targetMargin(val) {
      this.target_margin = val;
    },
    value: {
      deep: true,
      handler(val) {
        this.data_incoming = true;
        if (!this.dirty) {
          this.template = JSON.parse(JSON.stringify(val));
        }
      },
    },
    template: {
      deep: true,
      handler(val) {
        if (this.data_incoming) {
          this.data_incoming = false;
          return;
        }

        this.$emit("change", val);
      },
    },
  },
  data() {
    return {
      template: false,
      data_incoming: false,
      show_mode: "prices",
      dirty: false,
    };
  },
};
</script>